import PluginsCategories from './PluginsCategories'

export default PluginsCategories
